import { getGlobalSingleton } from '../carrier.js';
import { DEBUG_BUILD } from '../debug-build.js';
import { GLOBAL_OBJ } from './worldwide.js';
var CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'];

/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';

/** This may be mutated by the console instrumentation. */
var originalConsoleMethods = {};

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
  if (!('console' in GLOBAL_OBJ)) {
    return callback();
  }
  var console = GLOBAL_OBJ.console;
  var wrappedFuncs = {};
  var wrappedLevels = Object.keys(originalConsoleMethods);

  // Restore all wrapped console methods
  wrappedLevels.forEach(function (level) {
    var originalConsoleMethod = originalConsoleMethods[level];
    wrappedFuncs[level] = console[level];
    console[level] = originalConsoleMethod;
  });
  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    wrappedLevels.forEach(function (level) {
      console[level] = wrappedFuncs[level];
    });
  }
}
function enable() {
  _getLoggerSettings().enabled = true;
}
function disable() {
  _getLoggerSettings().enabled = false;
}
function isEnabled() {
  return _getLoggerSettings().enabled;
}
function log() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  _maybeLog.apply(void 0, ['log'].concat(args));
}
function warn() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  _maybeLog.apply(void 0, ['warn'].concat(args));
}
function error() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  _maybeLog.apply(void 0, ['error'].concat(args));
}
function _maybeLog(level) {
  for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }
  if (!DEBUG_BUILD) {
    return;
  }
  if (isEnabled()) {
    consoleSandbox(function () {
      var _GLOBAL_OBJ$console;
      (_GLOBAL_OBJ$console = GLOBAL_OBJ.console)[level].apply(_GLOBAL_OBJ$console, ["".concat(PREFIX, "[").concat(level, "]:")].concat(args));
    });
  }
}
function _getLoggerSettings() {
  if (!DEBUG_BUILD) {
    return {
      enabled: false
    };
  }
  return getGlobalSingleton('loggerSettings', function () {
    return {
      enabled: false
    };
  });
}

/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 */
var debug = {
  /** Enable logging. */
  enable: enable,
  /** Disable logging. */
  disable: disable,
  /** Check if logging is enabled. */
  isEnabled: isEnabled,
  /** Log a message. */
  log: log,
  /** Log a warning. */
  warn: warn,
  /** Log an error. */
  error: error
};
export { CONSOLE_LEVELS, consoleSandbox, debug, originalConsoleMethods };